module.exports = __webpack_public_path__ + "static/img/banner.9534db85.jpg";